import Typography from "@mui/material/Typography";

const LeftCustomMenu = ({ children, color }) => {
  return (
    <Typography
      variant="body"
      color={color}
      fontWeight={color === "primary" ? 700 : 400}
    >
      {children}
    </Typography>
  );
};

export default LeftCustomMenu;
